export default "__VITE_ASSET__819e0f51__"